import microstrip, { effectiveDielectricConstant } from './microstrip';

const { sqrt, exp } = Math;

// source: IPC-2141A Equation 4-7
export function characteristicImpedance(params) {
  const { e, w, h1, h2 } = mapStandardParamsToFormulaParams(params);

  // var z0 = (87 / Math.sqrt(e+1.41)) * Math.log((5.98*h1)/(0.8*w+t)) * (1 - h2 / 0.1);
  const z0surf = microstrip.characteristicImpedance(params);
  const b = h2 - h1;
  const eEff = effectiveDielectricConstant(e, w, h1);
  const z0emb = z0surf / sqrt(exp(-2*b/h1) + (e/eEff) * (1 -  exp(-2*b/h1)));

  return z0emb;
}

// source: unknown
export function differentialImpedance(params) {
  const { s, h1, h2 } = mapStandardParamsToFormulaParams(params);
  const z0 = characteristicImpedance(params);

  const zDiff = 2*z0*(1-0.48*Math.exp(-0.96*s/(h1+h2)));
  return zDiff;
}

// source: unknown;
export function propagationalDelay(params) {
  const { e, h1, h2 } = mapStandardParamsToFormulaParams(params);

  const eEff = e * (1 + Math.exp(-1.55*h2/h1));
  var tPd = 84.75 * Math.sqrt(0.475*eEff+0.67)

  return tPd;
}

export function mapStandardParamsToFormulaParams(params) {
  const {
    dielectricUpHeight,
    dielectricDownHeight,
    dk,
    thickness,
    transmissionSpacing,
    transmissionWidth
  } = params;

  return {
    w: transmissionWidth,
    h1: dielectricDownHeight,
    h2: dielectricDownHeight + dielectricUpHeight + thickness,
    e: dk,
    t: thickness,
    s: transmissionSpacing,
  }
}

export default {
  characteristicImpedance,
  differentialImpedance,
  propagationalDelay
}


// WEBPACK FOOTER //
// ./src/lib/simulations/formulas/embedded-microstrip.js